

















import { Component } from 'vue-property-decorator';
import { pick } from 'lodash';

import DialogCreateFromTemplate from '@/components/dialogs/dialog-create-from-template.vue';
import {mixins} from 'vue-class-component';
import IntegrationMixin from '@/views/settings/integrations/custom-integrations/mixins/integration-mixin';
import NETWORK_LIST_IN_TILE_FORMAT from '@/views/reports/forms/traffic_sources/network-list-in-tile-format';
import TrafficSourceApi from '@/services/rest/bemob/traffic-source';

@Component({
  components: {
    DialogCreateFromTemplate
  }
})
export default class TrafficSourceFromTemplate extends mixins<IntegrationMixin>(IntegrationMixin) {
  networkListInTileFormat: any = NETWORK_LIST_IN_TILE_FORMAT;
  show: boolean = false;
  trafficSourceApi: TrafficSourceApi = new TrafficSourceApi();
  templates = []
  
  get itemsOthers() {
    return this.templates.filter((item:any)=>{
      const integrationInstance = this.integrationsData[item.integrationType];
      return (!item.main && !this.networkListInTileFormat[item.name])
    }) || [];
  }

  get itemsIntegrated() {
    return this.templates.filter((item:any)=>{
      const integrationInstance = this.integrationsData[item.integrationType];
      return item.main
    }) || [];
  }

  get itemPick() {
    let keys = ['name', 'postbackUrl', 'extClickIdParam', 'extClickIdPlaceholder', 'costParam', 'costPlaceholder', 'postbackSendConfirmStatus', 'main', 'integrationType'];
    for (let i = 1; i <= 10; i++) {
        keys.push('custom' + i + 'Param');
        keys.push('custom' + i + 'Placeholder');
        keys.push('custom' + i + 'Name');
    }

    return keys;
  }

  get itemsOthersTile() {
    return this.templates.filter((item:any)=>{
      return this.networkListInTileFormat[item.name]
    }) || [];
  }

  async getItem(id: string) {
    const templates = await this.trafficSourceApi.getTemplates()
    let item = templates.find((e: any) => e.id === id);
    if(item) {
      item = {
        ...pick(item, this.itemPick),
        postbackSendConfirmStatus: true
      }
    }

    this.close()
    this.bus.emit('open-dialog', { name: 'CreateTrafficSources', data: { item } });
  }

  close() {
    this.$emit('close');
  }

  mounted() {
    this.$store.commit('loading', true);

    this.trafficSourceApi.getTemplates().then((data) => {
      this.templates = data;
      this.show = true

      this.$store.commit('loading', false);
    }).then(() => {
      this.show = true

      this.$store.commit('loading', false);
    });
  }
}
